import React from 'react';

import { FirebaseContext } from './FirebaseProvider';

export const MockFirebaseProvider = ({ children }: { children: React.ReactNode }) => {
  return <FirebaseContext.Provider value={{ ready: true }}>{children}</FirebaseContext.Provider>;
};
